<script setup lang="ts">
import { IValidation } from "@/view-models/form.model"
import { computed } from "vue"
import ErrorMessage from "./ErrorMessage.vue"

import { createUuid } from "@/helpers/uuid.helper";

const modelValue = defineModel<string>({
    default: "",
})

const props = withDefaults(
    defineProps<{
        id: string
        label: string
        info?: string
        validation?: IValidation
        placeholder?: string
    }>(),
    {
        id: createUuid(),
        label: "",
        info: "",
        validation: undefined,
        placeholder: "",
    }
)

const validationFails = computed(() => {
    return props.validation?.model || props.validation?.invalid?.some((validation) => validation.value === true)
})

const isInvalid = computed(() => {
    if (validationFails.value && props.validation?.submitted) {
        return true
    }
    return false
})
</script>

<template>
    <div>
        <slot name="label" v-bind="{ isInvalid }">
            <label :class="{ 'text-danger': isInvalid }" class="font-bold" :for="id" v-text="label">
            </label>
        </slot>
        <slot name="info" v-bind="{ isInvalid }">
            <p v-if="info" :class="{ 'text-danger': isInvalid }" class="form-info-text" v-text="info"></p>
        </slot>
        <slot name="input" v-bind="{ isInvalid }">
            <input :id="id" v-model="modelValue" :class="{ 'is-invalid': isInvalid }" class="border-none w-full"
                type="email" :placeholder="placeholder" />
        </slot>
        <slot name="error" v-bind="{ isInvalid }">
            <error-message v-if="validation?.model && validation?.submitted && modelValue === ''"
                :message="validation?.message" />
            <template v-if="validation?.invalid && validation?.submitted && modelValue !== ''">
                <div v-for="(validationItem, i) in validation.invalid" :key="i">
                    <error-message v-if="validationItem.value" :message="validationItem.message" />
                </div>
            </template>
        </slot>
    </div>
</template>